import React from 'react';
import appStrings from '../../../../../common/app_strings';
import TimerSplashIntakePage from '../../../molecules/timerSplashIntake/TimerSplashPage';

const {
  wholemeIntake: {
    splashText: {
      thankYou: {
        title, subtitle, subtitle2, loadingText,
      },
    },
  },
} = appStrings;

const ThankYouBasicSplash = ({
  nextOnClick,
  paginationMeta,
}) => (
  <TimerSplashIntakePage
    nextOnClick={nextOnClick}
    paginationMeta={paginationMeta}
    pushTimer={8000}
    editText
    title={title}
    subtitle={subtitle}
    subtitle2={subtitle2}
    loadingText={loadingText}
  />
);
export default ThankYouBasicSplash;
